import {
  Box,
  Breadcrumbs,
  Container,
  Grid,
  Link,
  Typography,
} from "@material-ui/core";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { Helmet } from "react-helmet-async";
import { Link as RouterLink } from "react-router-dom";
import DateRangePickerCustom from "../../components/dashboard/DateRangePicker";
import PredictedTrendsWithSelects from "../../components/dashboard/charts/PredictedTrendsWithSelects";
import DestinationSelect from "../../components/dashboard/prediction/DestinationSelect";
import ChevronRightIcon from "../../icons/ChevronRight";
import { hasPermission } from "../../utils/handlePermissions";
import { useState } from "react";
import { subDays } from "date-fns";
import { useTranslation } from "react-i18next";

const DestinationByDepartureDates = () => {
  const { t } = useTranslation();
  const [selectionRange] = useState([
    {
      startDate: subDays(new Date("2023-07-31"), 30),
      endDate: new Date("2023-07-31"),
      key: "selection",
    },
  ]);

  return (
    <>
      {hasPermission("dashboard_analytics_destination") && (
        <>
          <Helmet>
            <title>
              Dashboard: {t("title.Destination by departure dates")} | Qtravel
              Search
            </title>
          </Helmet>
          <Box
            sx={{
              backgroundColor: "background.default",
              minHeight: "100%",
              py: 4,
            }}
          >
            <Container>
              <Grid
                container
                alignItems="end"
                justifyContent="space-between"
                spacing={3}
              >
                <Grid item>
                  <Typography color="textPrimary" variant="h5">
                    {t("title.Destination by departure dates")}
                  </Typography>
                  <Breadcrumbs
                    aria-label="breadcrumb"
                    separator={<ChevronRightIcon fontSize="small" />}
                    sx={{ mt: 1 }}
                  >
                    <Link
                      color="textPrimary"
                      component={RouterLink}
                      to="/dashboard/main"
                      variant="subtitle2"
                    >
                      Dashboard
                    </Link>
                    <Typography color="textSecondary" variant="subtitle2">
                      {t("title.Destination by departure dates")}
                    </Typography>
                  </Breadcrumbs>
                </Grid>
                <Grid item>
                  <DateRangePickerCustom
                    color={"primary"}
                    label={t(`other.analyze_msg`)}
                  />
                </Grid>
              </Grid>
              <Typography color="textSecondary" variant="h6" sx={{ py: 3 }}>
                {t("pages.prediction.select_msg")}
              </Typography>
              <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                <DestinationSelect selectionRange={selectionRange} />
                <Box sx={{ pt: 3 }}>
                  <DateRangePickerCustom
                    color={"warning"}
                    label={t(`other.departure_week`)}
                  />
                </Box>
              </Box>
              <Box sx={{ backgroundColor: "background.default", pt: 3 }}>
                <PredictedTrendsWithSelects
                  categories={[
                    "25-05-2023",
                    "26-05-2023",
                    "27-05-2023",
                    "28-05-2023",
                    "29-05-2023",
                    "30-05-2023",
                    "31-05-2023",
                    "01-06-2023",
                  ]}
                  data={{
                    min: [
                      1700.4, 2700, 3400.5, 3400.5, 4400.5, 4800.8, 5100.8,
                      4000.6,
                    ],
                    max: [
                      2300.1, 3100, 3800.1, 3900, 4500.1, 5800.9, 5800.5,
                      6600.5,
                    ],
                    avg: [2000, 2900, 3700, 3600, 4400, 5200, 5500, 5800],
                  }}
                  title={t(`other.countries`)}
                  tooltipInfo={t(`other.tooltip_Destination_country_1`)}
                />
              </Box>
            </Container>
          </Box>
        </>
      )}
    </>
  );
};

export default DestinationByDepartureDates;
